/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { computed } from 'mobx'
import { Badge, Menu } from 'antd'
import pathToRegexp from 'path-to-regexp'
import { isMobile } from 'react-device-detect'
import { RootConsumer } from '@shared/App/Provider'
import { arrayToTree, queryArray } from '@utils/index'
import { GlobalStore } from '@store/globalStore'
import { AuthStore } from '@store/authStore'
import { ComponentStore } from '@store/componentStore'
// css
import BettingRules from '@views/BettingRules'
import { MatchupStore } from '@store/matchupStore'
import { GENERAL_POPUP_ID, HISTORY_TYPE, SIDE_MENU } from '@constants/index'
import Club from '@views/Club'
import ItemShop from '@views/ItemShop'
import BettingHistory from '@views/BettingHistory'
import MyBank from '@views/MyBank'
import MyPage from '@views/MyPage'
import Pick from '@views/Pick'
// import Mission from '@views/Mission'
import { bettingHistoryStore, componentStore, userStore } from '@store/index'
import * as _ from 'lodash'
import { isAccountForTesting } from '@utils/utils'
import FriendsInvitation from '@views/FriendsInvitation'
import Notice from '@views/Notice'
import menus, { filterMenus, MenuInTree, RouteMenu } from '../menu'
import { IconStyle, MenuItemContainer, MenuItemWrap } from './index.style'
import { PAGE_TYPE } from '@interface/common'
import BettorFind from '@views/BettorFind'
import { LogStore } from '@store/logStore'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

interface SiderMenuProps {
  routerStore: RouterStore
  globalStore: GlobalStore
  authStore: AuthStore
  matchupStore: MatchupStore
  componentStore: ComponentStore
  logStore: LogStore
}

@observer
class SiderMenu extends React.PureComponent<SiderMenuProps> {
  private levelMap: NumberObject = {}

  private readonly routerStore: RouterStore

  private readonly globalStore: GlobalStore

  private readonly authStore: AuthStore

  private readonly matchupStore: MatchupStore

  private readonly componentStore: ComponentStore

  private readonly logStore: LogStore

  constructor(props: SiderMenuProps) {
    super(props)
    this.routerStore = props.routerStore
    this.globalStore = props.globalStore
    this.authStore = props.authStore
    this.matchupStore = props.matchupStore
    this.componentStore = props.componentStore
    this.logStore = props.logStore
  }

  @computed
  get currentRoute() {
    return this.props.routerStore.location.pathname
  }

  @computed
  get menuProps() {
    const { visibleSideBar, navOpenKeys } = this.globalStore
    if (visibleSideBar) {
      return {
        onOpenChange: this.onOpenChange,
        openKeys: navOpenKeys,
      }
    }
    return {}
  }

  menuTree = () => {
    // const { signedin = false } = this.props
    const userId = this.authStore.userInfo?.id || ''
    const filteredMenu = filterMenus(
      true,
      this.authStore.isSpecificClubMember,
      this.globalStore.getMissionEnabled(),
      isAccountForTesting(userId),
      this.globalStore.getFriendInvitationEnabled(),
      this.componentStore.isPossibleInvitor,
    )
    const availableMenu = filteredMenu.filter((el: RouteMenu) => {
      return el.invisible !== true
    })

    return arrayToTree<MenuInTree>(availableMenu, 'id', 'pid')
  }

  showModalMenu = (selectedMenu: RouteMenu) => {
    const { authInfo } = this.authStore
    if (selectedMenu.namespace === SIDE_MENU.MESSAGE) {
      this.componentStore.setExtraClubId(null)
      this.globalStore.setVisibleMessageBox(true)
    } else if (selectedMenu.namespace === SIDE_MENU.GIFTBOX) {
      this.globalStore.setVisibleGiftBox(true)
    } else if (selectedMenu.namespace === SIDE_MENU.ATTENDANCE) {
      this.globalStore.setVisibleAttendance(true)
    } else if (selectedMenu.namespace === SIDE_MENU.CLUB) {
      this.globalStore.addGeneralPopupProperties(<Club/>, this.authStore.isSpecificClubMember ? '클럽정보' : '클럽이동', {
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'd040', buttonId: '001' }).catch(console.error)
        },
      })
    } else if (selectedMenu.namespace === SIDE_MENU.ITEM_SHOP) {
      this.globalStore.addGeneralPopupProperties(<ItemShop/>, '상점', {
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'd020', buttonId: '001' }).catch(console.error)
        },
      })
    } else if (selectedMenu.namespace === SIDE_MENU.BETTING_HISTORY) {
      bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BETTING_HISTORY)
      bettingHistoryStore.setBettingHistoryInitProps({
        onlyMajorClub: false,
        fromViewType: FROM_VIEW_TYPE.BETTING_HISTORY,
      })
      this.globalStore.addGeneralPopupProperties(<BettingHistory/>, '베팅 내역', {
        wrapClassName: '',
        className: '',
        isScroll: false,
        custom: false,
        clsBtn: false,
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'c010', buttonId: '002' }).catch(console.error)
        },
      })
    } else if (selectedMenu.namespace === SIDE_MENU.MY_BANK) {
      this.globalStore.addGeneralPopupProperties(<MyBank historyType={HISTORY_TYPE.MONEY}/>, '마이 뱅크', {
        wrapClassName: '',
        className: '',
        isScroll: false,
        custom: false,
        clsBtn: false,
      })
    } else if (selectedMenu.namespace === SIDE_MENU.PICK) {
      this.globalStore.addGeneralPopupProperties(<Pick/>, '픽거래소', {
        wrapClassName: '',
        className: '',
        isScroll: false,
        custom: false,
        clsBtn: false,
      }, null, GENERAL_POPUP_ID.PICK)
    } else if (selectedMenu.namespace === SIDE_MENU.BETTOR_FIND) {
      this.globalStore.addGeneralPopupProperties(<BettorFind/>, '베터 찾기', {
        isScroll: false,
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'd050', buttonId: '001' }).catch(console.error)
        }
      })
    } else if (selectedMenu.namespace === SIDE_MENU.MY_INFO) {
      this.globalStore.addGeneralPopupProperties(<MyPage/>, '마이 페이지', {
        className: 'my-page',
        isScroll: true,
      })
    } else if (selectedMenu.namespace === SIDE_MENU.MISSION) {
      if (_.size(userStore.missionList) === 0) {
        return
      }
      this.globalStore.setVisibleMissionListPopup(true)
    } else if (selectedMenu.namespace === SIDE_MENU.INQUIRY) {
      const inquiryHomepageUrl = `${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}/#/auth_login/${authInfo?.authKey}/inquiry`
      this.globalStore.toMoveWebHomePage(inquiryHomepageUrl, 'popup')
    } else if (selectedMenu.namespace === SIDE_MENU.GUIDE) {
      this.globalStore.setVisibleGuide(true)
    } else if (selectedMenu.namespace === SIDE_MENU.COUPON) {
      this.globalStore.setVisibleCouponInputPopup(true)
    } else if (selectedMenu.namespace === SIDE_MENU.BETTING_RULES) {
      this.globalStore.addGeneralPopupProperties(<BettingRules/>, '베팅 규정', {
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'd030', buttonId: '001' }).catch(console.error)
        }
      })
    } else if (selectedMenu.namespace === SIDE_MENU.NOTICE) {
      this.globalStore.addGeneralPopupProperties(<Notice/>, '공지사항', {
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'd060', buttonId: '001' }).catch(console.error)
        }
      })
    } else if (selectedMenu.namespace === SIDE_MENU.FRIENDS_INVITATION) {
      this.globalStore.addGeneralPopupProperties(<FriendsInvitation/>, '친구 초대', {
        className: 'my-page',
        closeCallback: () => {
          this.logStore.writeButtonLog({ pageId: 'e020', buttonId: '001' }).catch(console.error)
        }
      })
    }
  }

  goto = ({ key }: { key: string }) => {
    const { signedin = false } = this.authStore
    const { history } = this.props.routerStore
    const selectedMenu = menus.find(item => String(item.id) === key)

    if (selectedMenu) {
      switch (selectedMenu.namespace) {
        case SIDE_MENU.BETTING_HISTORY:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '005' }).catch(console.error)
          break
        case SIDE_MENU.MATCHUP_RESULT:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '006' }).catch(console.error)
          break
        case SIDE_MENU.MESSAGE:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '007' }).catch(console.error)
          break
        case SIDE_MENU.ITEM_SHOP:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '008' }).catch(console.error)
          break
        case SIDE_MENU.BETTING_RULES:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '009' }).catch(console.error)
          break
        case SIDE_MENU.CLUB:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '010' }).catch(console.error)
          break
        case SIDE_MENU.INQUIRY:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '011' }).catch(console.error)
          break
        case SIDE_MENU.BETTOR_FIND:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '012' }).catch(console.error)
          break
        case SIDE_MENU.GUIDE:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '013' }).catch(console.error)
          break
        case SIDE_MENU.COUPON:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '014' }).catch(console.error)
          break
        case SIDE_MENU.ATTENDANCE:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '015' }).catch(console.error)
          break
        case SIDE_MENU.NOTICE:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '016' }).catch(console.error)
          break
        case SIDE_MENU.FRIENDS_INVITATION:
          this.logStore.writeButtonLog({ pageId: 'd010', buttonId: '018' }).catch(console.error)
          break
      }
      this.globalStore.setVisibleSideBar(false)
      if (selectedMenu.signedin === true && signedin === false) {
        // 현재 메뉴를 선택시 로그인이 되어 있지 않다면 로그인 창을 바로 띄우기 때문에 불필요. dev.lhn 2023-01-06
        // 추후 메뉴를 로그인 하지 않아도 보여주게 된다면 여기에 관련 코드를 추가 하면된다.
        // 메뉴를 선택시 로그인이 필요한 메뉴 여부 판단. 로그인이 필요한데 로그인이 되어 있지 않다면 여기 코드 실행.
      } else if (!isMobile) {
        if (selectedMenu.namespace === SIDE_MENU.MATCHUP_RESULT) {
          history.push(selectedMenu.path)
        } else {
          this.showModalMenu(selectedMenu)
        }
      } else if (selectedMenu.path && selectedMenu.path !== this.currentRoute) {
        if (isMobile) {
          this.closeMatchupDetail()
        }
        this.globalStore.resetGeneralPopupProperties()
        history.push(selectedMenu.path)
      } else if (selectedMenu.namespace && selectedMenu.namespace.length) {
        if (isMobile) {
          if (selectedMenu.namespace === SIDE_MENU.MESSAGE ||
            selectedMenu.namespace === SIDE_MENU.ATTENDANCE ||
            selectedMenu.namespace === SIDE_MENU.GIFTBOX ||
            selectedMenu.namespace === SIDE_MENU.INQUIRY) {
            this.showModalMenu(selectedMenu)
          } else {
            this.closeMatchupDetail()
            this.globalStore.resetGeneralPopupProperties()
            history.push(selectedMenu.path)
          }
        } else {
          this.showModalMenu(selectedMenu)
        }
      }

      if (isMobile || (selectedMenu.namespace === SIDE_MENU.MATCHUP_RESULT)) {
        if (selectedMenu.namespace === SIDE_MENU.MATCHUP_RESULT) {
          this.matchupStore.setPageType(PAGE_TYPE.MATCHUP_RESULT)
        } else {
          this.matchupStore.setPageType(undefined)
        }
        this.matchupStore.setMatchTabInitializeSportId(undefined)
        this.matchupStore.setMatchTabInitializeMajorUniqueId(undefined)
        this.globalStore.setVisibleUserPick(false)
        this.globalStore.setVisibleAdvNews(false)
        this.globalStore.setVisibleGuide(false)
        this.globalStore.setVisibleTodayPick(false)
        this.closeMatchFilter()
      }
    }
  }

  closeMatchFilter = () => {
    this.matchupStore.resetTournamentFilterList()
    this.globalStore.setVisibleMatchFilterPopup(false)
  }

  closeMatchupDetail = () => {
    this.globalStore.setVisibleMatchupDetailPopup(false)
  }

  onOpenChange = (openKeys: string[]): void => {
    const { navOpenKeys, setOpenKeys } = this.globalStore
    const latestOpenKey = openKeys.find(key => !navOpenKeys.includes(key))
    const latestCloseKey = navOpenKeys.find(key => !openKeys.includes(key))
    let nextOpenKeys = []
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey)
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey)
    }
    setOpenKeys(nextOpenKeys)
  }

  getPathArray = (array: RouteMenu[], current: RouteMenu): string[] => {
    const result = [String(current.id)]
    const getPath = (item: RouteMenu): void => {
      if (item && item.pid) {
        result.unshift(String(item.pid))
        getPath(queryArray(array, String(item.pid), 'id'))
      }
    }
    getPath(current)
    return result
  }

  getAncestorKeys = (key: string): string[] => {
    const map = {}
    const getParent = (index: string) => {
      const result = [String(this.levelMap[index])]
      if (this.levelMap[result[0]]) {
        result.unshift(getParent(result[0])[0])
      }
      return result
    }
    for (const index in this.levelMap) {
      if ({}.hasOwnProperty.call(this.levelMap, index)) {
        map[index] = getParent(index)
      }
    }
    return map[key] || []
  }

  getMenus = (menuTree: MenuInTree[]) => {
    return menuTree.map(item => {
      return (
        <Menu.Item key={String(item.id)} css={IconStyle} className="menu-ico-style">
          {/* 서랍메뉴 상단 4개 아이콘 이미지(gradient ico) */}
          {item.iconImg &&
            <img src={item.iconImg} alt="" className="menu-ico-img"/>
          }
          {item.icon &&
            <Fragment>
              <item.icon/>
              {/* 안읽은 공지 있을경우 badge 추가 */}
              {(item.id === '16') && componentStore.noticeBadgeEnabled &&
                <Badge color="#DC2323" className="sider-notice-badge"/>}
            </Fragment>
          }
          <p>{item.locale}</p>
        </Menu.Item>
      )
    })
  }

  render() {
    this.levelMap = {}
    const { sideBarTheme } = this.globalStore
    const menuItems = this.getMenus(this.menuTree())
    let currentMenu: RouteMenu = null
    for (const item of menus) {
      if (item.path && pathToRegexp(item.path).exec(this.currentRoute)) {
        currentMenu = item
        break
      }
    }
    let selectedKeys: string[] = null
    if (currentMenu) {
      selectedKeys = this.getPathArray(menus, currentMenu)
    }
    if (!selectedKeys) {
      selectedKeys = ['1']
    }
    return (
      <MenuItemContainer className="menu-item-container">
        <MenuItemWrap className="menu-item-wrap">
          <Menu
            // className="MenuList"
            theme={sideBarTheme}
            mode="inline"
            selectedKeys={selectedKeys}
            onClick={this.goto}
            {...this.menuProps}
          >
            {menuItems}
          </Menu>
        </MenuItemWrap>
      </MenuItemContainer>
    )
  }
}

export default function Wrapper() {
  return (
    <RootConsumer>
      {({ routerStore, authStore, globalStore, matchupStore, logStore }) => (
        <SiderMenu
          key="SiderMenu"
          routerStore={routerStore}
          globalStore={globalStore}
          authStore={authStore}
          matchupStore={matchupStore}
          componentStore={componentStore}
          logStore={logStore}
        />
      )}
    </RootConsumer>
  )
}
